import {
	submitGameScore,
	saveGameState,
	deleteGameState,
	getMyRank
} from "../../utils/apiFunctions";
export default {
	data() {
		return {
			bestTry: 0,
			totalPlayed: 0,
		};
	},

	methods: {
		async submitScore(gametype, score) {
            try{
			let payload = {
				score: score,
			};
			const res = await submitGameScore(gametype, payload);
        }
        catch(error){
            console.log(error);
        }
		},

		async saveGameState(gametype, obj) {
            try{
			let payload = {
				game: gametype,
				state: obj,
			};
			const res = await saveGameState(payload);
        }
        catch(error){
            console.log(error);
        }
		},
		async deleteGameState(gametype) {
            try{
			const res = await deleteGameState(gametype);
            }
            catch(error){
                console.log(error);
            }
		},

		async getMyRank(gameType) {
			try {
				const res = await getMyRank(gameType);
				if (res.status == 200) {
					const all_scores = res.data.data.all_scores;
					if(all_scores.length == 0){
						this.bestTry = 0;
					}else{
					const scores = all_scores.map(entry => entry.score);
					const maxScore = Math.min(...scores);
					const bestTime = this.formatTime(maxScore);
					this.totalPlayed = all_scores.length;
					this.bestTry= bestTime;
					}
					
				}
			} catch (error) {
				console.log(error);
			}
		},
		 formatTime(seconds) {
			const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
			const minutes = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
			const secs = (seconds % 60).toString().padStart(2, '0');
			return `${hours}:${minutes}:${secs}`;
		}
	},
};
